<boi-radio-button-group *ngFor="let question of questions" [ngModel]="question.ProvidedAnswer"
    (ngModelChange)="changeQuestionAnswer(question, $event)" [optionList]="referenceDataOptionLists.AnswerType"
    [radioButtonGroupLabel]="question.Value" [controlId]="question.Code" [tooltipName]="question.Code"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>

<boi-radio-button-group [optionList]="referenceDataOptionLists.AnswerType" [required]="!caseSetup.IsRemortgage"
    [ngModel]="caseSetup.IsRemortgage" (ngModelChange)="changeIsRemortgage($event)"
    [labelName]="referenceDataLabels.EligibilityRemortgagingQuestion"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio mb-30'" [isTooltipLast]="false">
</boi-radio-button-group>

<boi-drop-down [ngModel]="caseSetup.PropertyLocation" (ngModelChange)="changePropertyLocation($event)"
    [optionList]="referenceDataOptionLists.PropertyLocation"
    [labelName]="referenceDataLabels.EligibilityPropertyTypeQuestion" [isTooltipLast]="false">
</boi-drop-down>
